module.exports = __webpack_public_path__ + "img/lslg.b23e521c.png";